import http from '@/http'
import { CurrencyDTO } from '@/interfaces/admin/currencies'

export const getCurrencies = async function(): Promise<CurrencyDTO> {
    const { data, headers} = await http.get('/organizations/currencies')
    return { data, headers }
}